import { Component, OnInit } from '@angular/core';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { RoutesKeys } from 'src/app/utils/routes';
import { maxNameLength } from 'src/app/utils/text-max-lenght';

@Component({
  templateUrl: './profile-created.page.html',
  styleUrls: ['./profile-created.page.scss'],
})
/**
 * Instantiates page template
 */
export class ProfileCreatedPage implements OnInit {
  businessName!: string;
  businessPhoto!: string;
  RoutesKeys = RoutesKeys;

  /**
   * @constructor
   */
  constructor(private readonly registerService: RegisterService) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.businessName =
      this.registerService.inviteNewBusiness?.businessName || '';
    this.businessPhoto =
      this.registerService.inviteNewBusiness?.imgSource || '';
    this.registerService.inviteNewBusiness = undefined;
  }

  /**
   * Checks if business name length is too big
   * @return {boolean}
   */
  maxNameLength(): boolean {
    return maxNameLength(this.businessName, 18);
  }
}
